import { Container, Row, Col } from "react-bootstrap";
import Button from "./Button";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { Maquinadeescrever } from "../page/Maquinadeescrever";


export default function Hero() {
  const codeString = `import React from 'react';

  function App() {
    return (
      <div>
        <header>
          <h1>Code Technology Store</h1>
        </header>
        <main>
          <p>Bem-vindo à loja de códigos do mercado.</p>
          <p>Conheça mais sobre nós!</p>
        </main>
      </div>
    );
  }
  
  export default App;
   `;
  return (
    <Container className="py-3">
      <Row>
        <Col lg={6} md={6} sm={12} className="d-flex align-items-center">
          <div className="text-lg-start text-md-start text-center">
            <h1 className="font-primary color-primary">Code Tech Store</h1>
            <p className="font-secondary color-secondary py-3">
            <Maquinadeescrever text="Bem-vindo à Code Tech Store (CTS), sua loja virtual de produtos em códigos e serviços para programadores! Oferecemos tudo o que você precisa para o desenvolvimento web, desde front-end até FullStack. Conte conosco para solucionar seus problemas e garantir sua satisfação. Com produtos e serviços de alta qualidade, a CTS é sua escolha confiável. Junte-se a nós agora e eleve suas habilidades de programação ao próximo nível!" />
            </p>
            <Button text="Visitar Loja" icon="bi bi-arrow-right" />
          </div>
        </Col>
        <Col lg={6} md={6} className="d-none d-lg-block">
          <div className="max-w-2xl min-w-[25rem] bg-[#3a404d] rounded-md overflow-hidden">
            <div className="flex justify-between px-2 text-white text-xs items-center"></div>
            <SyntaxHighlighter
              language="jsx"
              style={atomOneDark}
              customStyle={{
                padding: "25px",
              }}
              wrapLongLines={true}
            >
              {codeString}
            </SyntaxHighlighter>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
